import axios from "../../utils/axios";
import { isAzureFile } from "../contexts/HistoricAuditContext";
import type { PagedResponse } from "../types/api";
import type { AuditDTO } from "../types/auditDtos";

const apiUrl = process.env.REACT_APP_HS_API_URL;

const getBySiteExternalId = ({ siteExternalId, pageNum, pageSize }) =>
    axios.get<PagedResponse<AuditDTO>>(`${apiUrl}/historicaudit/site/${siteExternalId}?pageSize=${pageSize}&pageNum=${pageNum}`);

const update = (historicAuditId, historicAuditDTO) => {
    const formData = new FormData();

    if (historicAuditDTO.document !== null && !isAzureFile(historicAuditDTO.document)) {
        formData.append("document", historicAuditDTO.document);
    }

    formData.append("historicAuditDTO", JSON.stringify(historicAuditDTO));

    return axios.patch<AuditDTO>(`${apiUrl}/historicaudit/${historicAuditId}`, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        }
    });
}

const create = (historicAuditDTO, siteExternalId) => {
    const formData = new FormData();

    if (historicAuditDTO.document !== null && !isAzureFile(historicAuditDTO.document)) {
        formData.append("document", historicAuditDTO.document);
    }

    formData.append("historicAuditDTO", JSON.stringify(historicAuditDTO));
    formData.append("siteExternalId", siteExternalId ?? "");

    // Deferred: controller returns the raw `Data.Models.HistoricAudit` EF entity (saveResult.Value),
    // not the AuditDTO the [ProducesResponseType] claims. It opens a recursive/circular graph
    // (HistoricAudit -> Actions -> HistoricAction -> HistoricAudit, plus Documents). See summary.
    return axios.post(`${apiUrl}/historicaudit/create`, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        }
    });
}

const archive = (historicAuditId) =>
    axios.delete<void>(`${apiUrl}/historicaudit/${historicAuditId}`);

const historicAuditService = {
    getBySiteExternalId,
    update,
    create,
    archive,
};

export default historicAuditService;